import * as Yup from 'yup';

import userSchema from './user';

const userFormSchema = Yup.object({
  user: userSchema
});

export default userFormSchema;
export type UserFormSchema = ReturnType<typeof userFormSchema.cast>;
